<template>
  <Row>
    <Col :span="12" :offset="6">
      <Card>
        <p slot="title">
          <Icon type="ios-download" />数据导出
        </p>
        <div style="padding: 10px 0;">
          <Button
            type="dashed"
            icon="ios-cloud-download"
            size="large"
            @click="download('excel')"
            long
          >导出Excel文件</Button>
        </div>
        <div style="padding: 10px 0;">
          <Button type="dashed" icon="ios-download" size="large" @click="download('csv')" long>导出CSV文件</Button>
        </div>
        <div style="padding: 10px 0;">
          <Button
            type="dashed"
            icon="ios-cloud-download-outline"
            disabled
            size="large"
            long
          >导出SAS XPT文件</Button>
        </div>
        <!-- <Button type="success" @click="delRepeated" long> 删除重复</Button>&nbsp; -->
      </Card>
    </Col>
  </Row>
</template>

<script>
import { exportData } from '@/api/export'
import { DeleteRepeated } from '@/api/subject'

export default {
  name: 'export',
  data: () => ({}),
  methods: {
    delRepeated: function () {
      DeleteRepeated({}).then(async res => {
        this.$Message.success('去重重复记录')
      })
    },
    download: function (name) {
      exportData(name).then(async res => {
        this.$Message.success('下载成功')
        this.exportFile(res, this.getFileType(name), '数据库文件.' + this.getExt(name))
      })
    },
    getFileType (name) {
      let type = ''
      switch (name) {
        case 'excel':
          type =
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          break
        case 'csv':
          type = 'application/x-zip-compressed'
          break
        case 'pdf':
          type = 'application/x-zip-compressed'
          break
        case 'xpt':
          type = 'application/x-zip-compressed'
          break
        case 'odm':
          type = 'application/x-zip-compressed'
          break
        default:
          type =
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          break
      }
      return type
    },
    getExt (name) {
      const exts = {
        pdf: 'zip',
        txt: 'zip',
        csv: 'zip',
        xpt: 'zip',
        excel: 'xlsx',
        odm: 'zip'
      }
      return exts[name]
    },
    exportFile: function (res, type, filename) {
      const blob = new Blob([res], { type: type })
      var link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = filename
      link.click()
      window.URL.revokeObjectURL(link.href)
      this.closeLoading()
    }
  }
}
</script>
